var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKniha(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "transport",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18,2.5A2.5,2.5,0,0,0,15.5,0H2.5A2.5,2.5,0,0,0,0,2.5v19A2.5,2.5,0,0,0,2.5,24h15a.5.5,0,0,0,.22-.95A1.88,1.88,0,0,1,16.5,21.5,1.88,1.88,0,0,1,17.72,20a.39.39,0,0,0,.1-.08l0,0a.56.56,0,0,0,.1-.15.11.11,0,0,1,0-.05l0-.13V2.5ZM14,1v9.29L11.85,8.15a.48.48,0,0,0-.7,0L9,10.29V1ZM2.5,1H8V11.5a.5.5,0,0,0,.31.46.48.48,0,0,0,.54-.11L11.5,9.21l2.65,2.64a.47.47,0,0,0,.35.15.43.43,0,0,0,.19,0A.5.5,0,0,0,15,11.5V1h.5A1.5,1.5,0,0,1,17,2.5V19H2.5a2.51,2.51,0,0,0-1.5.51V2.5A1.5,1.5,0,0,1,2.5,1ZM16.05,23H2.5a1.5,1.5,0,0,1,0-3H16.05a2.32,2.32,0,0,0,0,3Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKniha);
export default __webpack_public_path__ + "static/media/Kniha.2694eecb61c73278a566dc4eec5ca772.svg";
export { ForwardRef as ReactComponent };